import request from '@/utils/request'


/**
 * 登录
 */
export function loginApi(username,password) {
    // const postData = {
    //     ...loginForm
    // }
    return request({
        url: '/admin/login',
        method: 'post',
        params: {username, password},
        // 登录错误由登录页统一转换为用户友好文案，避免展示后端技术堆栈
        noMessage: true
    })
}

/**
 * 注册
 */
export function registerApi(registerForm) {
    const postData = {
        ...registerForm
    }
    return request({
        url: '/admin/register',
        method: 'post',
        data: postData,
        noMessage: true
    })
}

/**
 * 注册手机验证码
 * @param {string} mobile 手机号
 * @param {string} captchaVerification AJ-Captcha 人机验证票据（发送前必须过滑块）
 */
export function sendRegisterSmsCodeApi(mobile, captchaVerification) {
    return request({
        url: '/admin/sms/sendTo',
        method: 'post',
        data: { mobile, captchaVerification },
        noMessage: true
    })
}

/**
 * 短信验证码登录
 */
export function smsLoginApi(mobile, code) {
    return request({
        url: '/admin/login/sms',
        method: 'post',
        params: { mobile, code },
        noMessage: true
    })
}

/**
 * 注销
 */
export function logout() {
    return request({
        url: '/admin/logout',
        method: 'post'
    })
}


export function LoginByUsername(username, password) {
    const data = {
        username,
        password
    }
    return request({
        url: '/login/login',
        method: 'post',
        data
    })
}

/**
 * 获取用户菜单
 * @returns
 * @constructor
 */
// export function getUserRoutersApi (){
//     return request({
//         url: `/admin/menus/list`,
//         method: 'get'
//     })
// }

/**
 * 获取用户信息
 * @returns
 * @constructor
 */
export function getUserInfoApi (){
    return request({
        url: `/admin/users/userInfo`,
        method: 'get',
        noMessage: true
    })
}

